export default "__VITE_ASSET__Dje4_E0T__"